import { Modal } from 'antd';
import Colors from 'assets/Colors';
import { useTranslation } from 'react-i18next';
import s from './styles';

function ConfirmModal({
  width = 428,
  height = 234,
  titleAlert,
  confirm1,
  confirm2,
  onConfirm,
  onCancel,
  hide,
  ...props
}) {
  const { t } = useTranslation();
  // {t("components.common.AddSubCategoryModal.addSubCategory")}
  return (
    <Modal
      {...props}
      transitionName=""
      width={width}
      height={height}
      centered
      footer={null}
      bodyStyle={{ padding: 0, overflow: 'auto' }}
      closable={false}
      maskStyle={{ backdropFilter: 'blur(10px)' }}
      visible
    >
      <s.Wrapper>
        <s.Title>{titleAlert}</s.Title>
      </s.Wrapper>

      <s.WrapperContents>
        {confirm1 && <s.info>{confirm1}</s.info>}
        {confirm2 && <s.info>{confirm2}</s.info>}
      </s.WrapperContents>

      <s.Line />

      <s.WrapperButtons>
        <s.Button
          onClick={() => {
            hide();
            onConfirm();
          }}
        >
          {t('actions.accept')}
        </s.Button>
        <s.Button
          style={{
            backgroundColor: '#fff',
            color: Colors.primary,
          }}
          onClick={() => {
            hide(), onCancel && onCancel();
          }}
        >
          {t('actions.cancel')}
        </s.Button>
      </s.WrapperButtons>
    </Modal>
  );
}

export default ConfirmModal;
